import React from 'react';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { TomosSection } from './components/TomosSection';
import { BonosSection } from './components/BonosSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { PricingSection } from './components/PricingSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FaqSection } from './components/FaqSection';
import { FinalCtaSection } from './components/FinalCtaSection';
export function App() {
  return <div className="w-full bg-white font-sans text-[#0f172a]" data-id="element-0" data-mp="31c9w477kb5t1">
      <Hero data-id="element-1" data-mp="2wjgq7g0cxrfd" />
      <main data-id="element-2" data-mp="2wiyx2s8zrtbo">
        <ProblemSection data-id="element-3" data-mp="2wj8evsjvuu6a" />
        <SolutionSection data-id="element-4" data-mp="2whxb3sqftmf6" />
        <TomosSection data-id="element-5" data-mp="28u5x8kp911bs" />
        <BonosSection data-id="element-6" data-mp="28tmej1rry8wp" />
        <TestimonialsSection data-id="element-7" data-mp="28sutulzptvl7" />
        <PricingSection data-id="element-8" data-mp="28s2zfehuu3wi" />
        <GuaranteeSection data-id="element-9" data-mp="23vuokdaowwv5" />
        <FaqSection data-id="element-10" data-mp="23ujksdh8vp41" />
        <FinalCtaSection data-id="element-11" data-mp="23v2rsz5cwt3a" />
      </main>
      <footer className="w-full border-t border-white/10 bg-[#0f172a] py-8" data-id="element-12" data-mp="3ik7fqfdqo9q4">
        <p className="mx-auto max-w-6xl px-6 text-center text-xs text-slate-600" data-id="element-13" data-mp="3ii4sg33z0up3">
          Mega Pack Nutrición · Sistema de Nutrición Atlética · Argentina
        </p>
      </footer>
    </div>;
}